import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get, find } from 'lodash'
import { RadioGroup, Radio } from 'components/fields'
import { MaterialModal } from 'components/layout'
import { Note } from 'components/misc'
import { form } from 'helpers/decorators'
import { apiDashboard } from 'helpers/decorators/api'
import { mayBecomeMajor } from 'helpers/dashboard'
import validate from './change-major-activity.validation'

@apiDashboard.apiActivity({
  loaders: ['edit']
})
@form({
  form: 'changeMajorActivity',
  disableHook: true,
  validate
})
class ChangeMajorActivity extends Component {
  static propTypes = {
    activities: PropTypes.array,
    onEditActivity: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    editStatus: PropTypes.object,
    errors: PropTypes.object,
    colorClass: PropTypes.string
  }

  componentDidMount() {
    const { change, activities } = this.props
    const { major } = mayBecomeMajor(activities)

    change('major', get(major, 'id'))
  }

  handleSubmit = fields => {
    const majorId = get(fields, 'major')
    const chosenActivity = find(
      this.props.activities,
      act => act.id === majorId
    )

    return this.props.onEditActivity(
      majorId,
      { ...chosenActivity, isMajor: true },
      {
        resetForm: this.props.reset,
        activity: get(this.props.activities, `ID_${get(fields, 'major')}`)
      }
    )
  }

  render() {
    const { activities, editStatus, colorClass, handleSubmit } = this.props

    const { isMajorDone, mayBeMajorGrouped, mayBeMajor } = mayBecomeMajor(
      activities
    )

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Note intlKey="label.major_activity_means_that_you_will">
          Major Activity means that you will have to spend an extended amount of
          time on this activity compared to the others. For Gold and Silver the
          extra time required is six months, for Bronze it is three months.'
        </Note>

        {!isMajorDone &&
          Array.isArray(mayBeMajor) &&
          mayBeMajor[0] &&
          <RadioGroup
            label="Major activity"
            labelless
            name="major"
            errors={this.props.errors}
            horizontal
          >
            {Object.keys(mayBeMajorGrouped).map(section =>
              <Radio
                key={get(mayBeMajorGrouped[section], '[0].id')}
                name="major"
                value={get(mayBeMajorGrouped[section], '[0].id')}
                label={get(
                  mayBeMajorGrouped[section],
                  '[0].activitySection.translationText'
                )}
              />
            )}
          </RadioGroup>}

        {isMajorDone &&
          <strong>
            <Note intlKey="label.you_cant_change_your_major_activity">
              You can't change your major activity. Your major activity has
              already been completed
            </Note>
          </strong>}

        {(!Array.isArray(mayBeMajor) || !mayBeMajor[0]) &&
          <strong>
            <Note intlKey="label.your_must_first_setup_some_activity">
              Your must first setup some activity
            </Note>
          </strong>}

        {!isMajorDone &&
          Array.isArray(mayBeMajor) &&
          mayBeMajor[0] &&
          <MaterialModal.Footer
            action="Save"
            actionKey="button.save"
            colorClass={colorClass}
            insideContent
            isLoading={get(editStatus, 'loading')}
          />}
      </form>
    )
  }
}

export default ChangeMajorActivity
